import { Component, OnInit, Output,Input ,EventEmitter } from '@angular/core';
import { MatTableDataSource,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../../models/messages';
import { DesembolsoService } from '../../../../services/tesoreria/desembolso/desembolso.service';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
};

declare var $: any;

@Component({
    selector: 'app-generar-desembolsoLiquidacion',
    templateUrl: './generar-desembolsoLiquidacion.component.html',
    styleUrls: ['./generar-desembolsoLiquidacion.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,
      DatePipe,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})

export class GenerarDesembolsoLiquidacionComponent implements OnInit{
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

    idEmpresa : number = 0;
    liquidaciones:any = [];
    liquidacionesDet: any = [];
    user:any;
    Simboloi:string;
    dataDesembolso : any = [];
    datares:any = [];
    LiquidacionesTotales:any = [];
    cont:number = 0;
    loading:boolean=false;
    @Input() DesembolsoGeneral:any = [];
    @Output() cerrarGenerarDesembolsoLiquidacion: EventEmitter<boolean>;

    formularioGenerarDesembolsoLiquidacion : FormGroup;
    formularioCrearDesembolsoLiquidacion : FormGroup;

    dataSource :any;
    dataSourceConDetalle :any;
    constructor(
        private datepipe :DatePipe,
        private routerActive:ActivatedRoute,
        private router:Router, 
        private desembolsoService:DesembolsoService,
        private msgTitulos : MessagesTitles,
        private loginService:LoginService
    ){
        
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.routerActive.params.subscribe( params => {
  
      this.cerrarGenerarDesembolsoLiquidacion = new EventEmitter();

      
      this.idEmpresa = params['id']; 
  })
    this.formularioGenerarDesembolsoLiquidacion = new FormGroup({
      "idResumen_Liquidaciones":new FormControl('', Validators.required),
      "idUser":new FormControl(''),
      "Proveedor": new FormControl('',  Validators.required),
      "Adquirente": new FormControl('',  Validators.required),
      "MonedaDescripcion": new FormControl('',  Validators.required),
      "Fecha_Contrato": new FormControl('',  Validators.required),
      "Adelanto":new FormControl('',  Validators.required),
      "TEM":new FormControl('',  Validators.required),
      "Desembolso":new FormControl('',Validators.required)
    
});

  this.formularioCrearDesembolsoLiquidacion = new FormGroup({
    Tipo_de_planilla  :new FormControl(''),
    Moneda : new FormControl(''),
    Importe :new FormControl(''),
    Alta_Usuario : new FormControl(''),
    idResumen_Liquidaciones : new FormControl(''),
  });
    }

    ngOnInit(){
      console.log(this.DesembolsoGeneral);
      this.dataSource = new MatTableDataSource(this.DesembolsoGeneral);
    }

    CerrarPopUp(){
      this.cerrarGenerarDesembolsoLiquidacion.emit();
    }

    guardarDesembolso(){            
      let Liquidaciones :any = [];
      let montoTotal :number = 0;
      
      for(let array of this.DesembolsoGeneral){
        this.formularioCrearDesembolsoLiquidacion.controls['Tipo_de_planilla'].setValue("1338");
        this.formularioCrearDesembolsoLiquidacion.controls['Moneda'].setValue(array.Moneda);
        this.formularioCrearDesembolsoLiquidacion.controls['Alta_Usuario'].setValue(this.user.Usuario);
        montoTotal += parseFloat(array.Desembolso_Importe);
        Liquidaciones.push(array.idResumen_Liquidaciones);
      }
      
      this.formularioCrearDesembolsoLiquidacion.controls['Importe'].setValue(montoTotal);
      this.formularioCrearDesembolsoLiquidacion.controls['idResumen_Liquidaciones'].setValue(Liquidaciones);
      this.loading = true;
      Swal.fire({
          title: "Espere...",
          text: "Guardando información",
          type: "info",
          allowOutsideClick: false,
          heightAuto: false
      });
      Swal.showLoading();      
      this.desembolsoService.crearDesembolsoLiquidacion(this.formularioCrearDesembolsoLiquidacion.getRawValue()).subscribe(
        res=>{
          Swal.fire({
            title: "¡Éxito!",
            text: "Desembolso guardado correctamente.",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value){
              this.loading = false;
              this.showNotification('success','top','right','Se envio correo con pdf adjunto.');
              this.loginService.clickGuard = true;             
              this.router.navigate(["/tesoreria/desembolso/listado"]);
            }
          });
        },err =>{
          this.loading = false;
          if (err.error.code == 500) {
            err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
        }else{
          let error = "";
            error = err.error.error;
            this.showNotification('warning','top','right','No se pudo enviar pdf. \n Error: ' + error);
        }
          Swal.fire({
            title: this.msgTitulos.Error_Algo_Salio_Mal,
            text: err.error.error,
            type: "warning",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      );
    }

    showNotification(type,from,align,message){

      $.notify({
          icon: "notifications",
          message: message
      },{
          type: type,
          timer: 4000,
          placement: {
              from: from,
              align: align
          },
          template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
            '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
            '<i class="material-icons" data-notify="icon">notifications</i> ' +
            '<span data-notify="title">{1}</span> ' +
            '<span data-notify="message">{2}</span>' +
            '<div class="progress" data-notify="progressbar">' +
              '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
            '</div>' +
            '<a href="{3}" target="{4}" data-notify="url"></a>' +
          '</div>'
      });
    }

}